import type { OpportunitySet, OpportunityTabKey } from "../types/opportunities.types"

/**
 * Import batches hold scripts on the synthetic custom opportunity, which is
 * hidden from the opportunities table. Open those sets on Completed Scripts.
 */
export function defaultOpportunityTabForSet(
  set: Pick<OpportunitySet, "activeCount" | "completedScriptsCount"> | null,
): OpportunityTabKey {
  if (set && set.activeCount === 0 && set.completedScriptsCount > 0) {
    return "completed_scripts"
  }
  return "active"
}
